import { Injectable } from '@angular/core';
import { Item } from '../models/item.model';
import { API_URL } from '../config/config';
import { HttpClient } from '@angular/common/http';
import { Signal } from '../models/signal.model';
import { Forex } from '../models/forex.model';
import { Onebet } from '../models/onebet.model';

@Injectable({
  providedIn: 'root'
})
export class PushNotificationService {

  constructor(public http: HttpClient) { }

  postPushNotificationAll(item: Item) {
    const url = API_URL + '/pushNotifications';
    return this.http.post(url,
      {
        title: item.name,
        body: item.description,
      }
    );
  }

  postPushNotificationToActives(item: Item) {
    const url = API_URL + '/pushToActive';
    return this.http.post(url,
      {
        title: item.name,
        body: item.description,
      }
    );
  }

  postPushNotificationSignal(signal: Signal) {
    const url = API_URL + '/pushToActive';
 
    const body = {
      title: '🚀 Señal de Índices Sintêticos 🚀',
      body:
        `NUEVA SEÑAL! 🔥🔥🔥`
    };
    return this.http.post(url,
      body
    );
  }
  // body: `${signal.type} ${signal.currency} PE:${signal.entryPrice} TE:${signal.estimatedTime}`
  putPushNotificationSignal(signal: Signal) {
    const url = API_URL + '/pushToActive';

    const body = {
      title: '🚀 Señal de Índices Sintêticos 🚀',
      body:
      `ACTUALIZACIÓN! 🚀🚀🚀`
    };
    return this.http.post(url,
      body
    );
  }

  postPushNotificationForex(signal: Forex) {
    const url = API_URL + '/pushToForex';
    const body = {
      title: '🔥 Señal de Forex 🔥',
      body:
        `NUEVA SEÑAL! 🔥🔥🔥`
    };
    return this.http.post(url,
      body
    );
  }
  // postPushNotificationForex(signal: Forex) {
  //   const url = API_URL + '/pushToForex';
  //   const body = {
  //     title: '🔥 Señal de Forex 🔥',
  //     body:
  //       `${signal.type.toUpperCase()} ${signal.currency} PE:${signal.entryPrice} SL:${signal.stopLoss}
  //        TP1:${signal.tp1} TP2:${signal.tp2} TP3:${signal.tp3} TP4:${signal.tp4}`
  //   };
  //   return this.http.post(url,
  //     body
  //   );
  // }

  updatePushNotificationForex(signal: Forex) {
    const url = API_URL + '/pushToForex';
    const body = {
      title: '🔥 Señal de Forex 🔥',
      body:
        `ACTUALIZACIÓN! 🔥🔥🔥`
    };
    return this.http.post(url,
      body
    );
  }
  // updatePushNotificationForex(signal: Forex) {
  //   const url = API_URL + '/pushToForex';
  //   const body = {
  //     title: '🔥 Señal de Forex 🔥',
  //     body:
  //       `ACTUALIZACIÓN: ${signal.type.toUpperCase()} ${signal.currency} - ${signal.description}
  //        - SL:${signal.stopLoss} - ${this.getStatusFromSignal(signal.status)}`
  //   };
  //   return this.http.post(url,
  //     body
  //   );
  // }

  postPushNotificationOneBet(signal: Onebet) {
    const url = API_URL + '/pushToGold';
    const body = {
      title: '⚽️ Señal de OneBet ⚽️',
      body:
        `${signal.title.toUpperCase()} - EVENTO: ${signal.event} - MOMIOS: ${signal.momios} - APUESTA: ${signal.bet}
         - ESTADO: ${this.getStatusFromSignal(signal.status)}`
    };
    return this.http.post(url,
      body
    );
  }

  updatePushNotificationOneBet(signal: Onebet) {
    const url = API_URL + '/pushToGold';
    const body = {
      title: '⚽️ Señal de OneBet ⚽️',
      body:
        `ACTUALIZACIÓN: ${signal.title.toUpperCase()} - EVENTO: ${signal.event} - MOMIOS: ${signal.momios} - APUESTA: ${signal.bet}
        - ESTADO: ${this.getStatusFromSignal(signal.status)}`
    };
    return this.http.post(url,
      body
    );
  }

  getStatusFromSignal(status) {
    switch (status) {
      case '':
        return '';
      case 'won':
        return 'GANADA';
      case 'lost':
        return 'PERDIDA';
      case 'canceled':
        return 'CANCELADA';
      case 'live':
        return 'EN VIVO';
      case 'push':
        return 'PUSH';
      default:
        break;
    }
  }
}
